import React, { Component } from 'react';
import survey_header from '../images/survey_header.png';
import { translate } from 'react-i18next';

class SurveyHeader extends Component {
  render() {
    const { t } = this.props;
    return(
      <nav className="header-padding" >
        <div >
            <div className="text-center">
              <img alt="IOS OFFICES" className="header-banner" src={survey_header} />
            </div>
        </div>
      </nav>
    );
  }
}

export default translate('common')(SurveyHeader);



// WEBPACK FOOTER //
// ./src/guest/SurveyHeader.js